export enum CameraProjection {
  Orthographic = 'Orthographic',
  Perspective = 'Perspective',
}
